declare const Liferay: any;

export const LANGUAGE: Record<string, string> = {
    more: (Liferay.Language.get('more') as string) || 'More',
    'view-details':
        (Liferay.Language.get('view-details') as string) || 'View Details',
    offers: (Liferay.Language.get('offers') as string) || 'Offers',
    'service-offer-value':
        (Liferay.Language.get('service-offer-value') as string) ||
        'Service Offer Value',
    'value-added':
        (Liferay.Language.get('value-added') as string) || 'Value Added',
    discount: (Liferay.Language.get('discount') as string) || 'Discount',
    descriptions:
        (Liferay.Language.get('descriptions') as string) || 'Descriptions',
    benefits: (Liferay.Language.get('benefits') as string) || 'Benefits',
    'eligibility-criteria':
        (Liferay.Language.get('eligibility-criteria') as string) ||
        'Eligibility Criteria',
    'start-date':
        (Liferay.Language.get('start-date') as string) || 'Start Date',
    'end-date': (Liferay.Language.get('end-date') as string) || 'End Date',
    'apply-now': (Liferay.Language.get('apply-now') as string) || 'Apply Now',
    'read-more': (Liferay.Language.get('read-more') as string) || 'Read More',
    'read-less': (Liferay.Language.get('read-less') as string) || 'Read Less',
    aed: (Liferay.Language.get('aed') as string) || 'AED',
    'service-offering-heading':
        (Liferay.Language.get('service-offering-heading') as string) ||
        'We offer you',
    'search-input-placeholder':
        (Liferay.Language.get('search-input-placeholder') as string) ||
        'Search',
    'no-data-found':
        (Liferay.Language.get('no-data-found') as string) || 'No Data Found',
    'no-data-found-description':
        (Liferay.Language.get('no-data-found-helper-text') as string) ||
        'Whoops... this information is not available for a moment.',
    'membership-login-form-heading':
        (Liferay.Language.get('membership-login-form-heading') as string) ||
        'Membership Details',
    'membership-login-form-subheading':
        (Liferay.Language.get('membership-login-form-subheading') as string) ||
        'Please verify your details',
    'members-price':
        (Liferay.Language.get('members-price') as string) || 'Members Price',
    'value-added-add-on':
        (Liferay.Language.get('value-added-add-on') as string) || 'Add-On',
    'value-added-discount-with-add-on':
        (Liferay.Language.get('value-added-discount-with-add-on') as string) ||
        'Discount with Add-on'
};
